(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-instalment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-instalment')) {
  customElements.define('mr-instalment', class extends HTMLElement {
    connectedCallback() {
      this.prices = JSON.parse(this.querySelector('script').textContent);
      this.form = this.closest('form');
      this.variantHandler = event => this.update(event.detail?.variant?.id);
      this.changeHandler = () => requestAnimationFrame(() => this.update(this.form?.querySelector('[name="id"]')?.value));
      document.addEventListener('variant:changed', this.variantHandler);
      this.form?.addEventListener('change', this.changeHandler);
    }
    update(id) {
      if (!(String(id) in this.prices)) return;
      const amount = Math.round(this.prices[id] / 4) / 100;
      this.querySelector('[data-instalment-amount]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency}).format(amount);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.variantHandler);
      this.form?.removeEventListener('change', this.changeHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mr-shorts-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-shorts-bundle')) {
  customElements.define('mr-shorts-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.first = this.querySelector('[data-first]');
      this.product = this.querySelector('[data-second-product]');
      this.second = this.querySelector('[data-second]');
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[role="status"]');
      this.label = this.button.textContent;
      this.product.addEventListener('change', () => {
        const template = Array.from(this.querySelectorAll('template')).find(t => t.dataset.options === this.product.value);
        this.second.replaceChildren(...(template ? template.content.cloneNode(true).childNodes : []));
        this.second.disabled = !template;
        this.refresh();
      });
      this.first.addEventListener('change', () => this.refresh());
      this.second.addEventListener('change', () => this.refresh());
      this.button.addEventListener('click', () => this.add());
    }
    refresh() {
      this.button.disabled = this.busy || !this.first.value || !this.second.value;
      this.status.textContent = '';
    }
    async add() {
      if (this.busy) return;
      if (!this.first.value || !this.second.value) { this.status.textContent = this.dataset.unavailable; return; }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.status.textContent = '';
      const quantities = new Map();
      [this.first.value, this.second.value].forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:Array.from(quantities, ([id,quantity]) => ({id:Number(id),quantity}))})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        this.status.textContent = this.dataset.success;
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message === 'Failed to fetch' ? this.dataset.error : error.message;
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = this.label;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
